import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import parse from 'html-react-parser'

export default function ExperienceEdit() {
  const id = useQueryValue('id', 0)

  const { data } = useApi({
    id: 'experienceDetail',
    fn: api().adminExperience.getExperienceDetail,
    params: id,
    enabled: !!id,
  })

  return (
    <ContentDetailView data={data} title="체험단 상세">
      <DetailForm
        data={data}
        fields={[
          {
            key: 'category.name',
            label: '카테고리',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'region.name',
            label: '지역',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'author.userData.nickname',
            label: '작성자',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'title',
            label: '체험단 제목',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'content',
            label: '상세내용',
            type: FormFieldType.CUSTOM_READ_ONLY,
            readOnly: true,
            render(data, context) {
              return <div>{parse(data?.content || '')}</div>
            },
          },
        ]}
      />
    </ContentDetailView>
  )
}
